import { postRequest } from "../../services/apiService";
import { TERMS_VERSION } from "./legal-config";

/**
 * Record that the signed-in member agreed to the current Terms version.
 * Resolves false on any failure so the caller can leave the prompt up rather
 * than pretending an acceptance was stored.
 */
export const acceptCurrentTerms = async (): Promise<boolean> => {
  try {
    // postRequest resolves the response body, or null when the call failed.
    const data = await postRequest("/api/v1/legal/terms/accept", {
      version: TERMS_VERSION,
    });
    return data?.version === TERMS_VERSION;
  } catch {
    return false;
  }
};
